var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchLong = function SvgSearchLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m11.067 12-4.2-4.2a4.063 4.063 0 0 1-2.533.867q-1.818 0-3.076-1.259T0 4.333q0-1.816 1.258-3.075Q2.518 0 4.333 0 6.15 0 7.408 1.258q1.26 1.26 1.259 3.075A4.06 4.06 0 0 1 7.8 6.867l4.2 4.2zM4.333 7.333q1.25 0 2.125-.875a2.9 2.9 0 0 0 .875-2.125q0-1.25-.875-2.125a2.9 2.9 0 0 0-2.125-.875q-1.25 0-2.125.875a2.9 2.9 0 0 0-.875 2.125q0 1.25.875 2.125a2.9 2.9 0 0 0 2.125.875"
  })));
};
export default SvgSearchLong;